import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Full-bleed background — professional tree crew at work */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fb29ab92ff82373a4175ad5988230969.jpg"
          alt="Safe professional tree removal service by Diversified Tree Services Northern Virginia"
          className="w-full h-full object-cover object-center"
        />
        {/* Layered overlay for maximum text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f2018]/95 via-[#0f2018]/80 to-[#0f2018]/25"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f2018]/60 via-transparent to-transparent"></div>
      </div>

      {/* Angled accent block */}
      <div
        className="absolute left-0 top-0 bottom-0 w-[55%] hidden xl:block pointer-events-none"
        style={{
          background: "linear-gradient(108deg, rgba(15,32,24,0.6) 60%, transparent 100%)",
        }}
      />

      <div className="relative w-full max-w-7xl mx-auto px-4 lg:px-8 pt-10 pb-32 lg:pb-40">
        <div className="max-w-2xl">
          {/* Urgency pill */}
          <div className="inline-flex items-center gap-2.5 bg-[#e8632a] text-white text-xs font-black uppercase tracking-[2px] px-4 py-2 rounded-full mb-7">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
            Free Estimates · Fast Response · Licensed &amp; Insured
          </div>

          {/* Main headline — benefit-driven, bold */}
          <h1 className="text-5xl lg:text-[68px] font-black text-white leading-[1.05] tracking-tight mb-6">
            Safe, Professional<br />
            <span className="text-[#e8632a]">Tree Removal</span>{" "}
            <span className="text-white">&amp; Trimming</span><br />
            <span className="text-white/90">You Can Trust.</span>
          </h1>

          <p className="text-white/75 text-xl leading-relaxed mb-8 max-w-xl font-medium">
            Diversified Tree Services LLC delivers expert tree removal, trimming, and stump grinding across Northern Virginia — with same-day response, upfront pricing, and a crew that leaves your yard spotless.
          </p>

          {/* CTA pair */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <Link
              to="/contact"
              className="group flex items-center justify-center gap-2.5 px-8 py-4 bg-[#e8632a] text-white font-black text-lg rounded-xl uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-xl"></i>
              Request Free Estimate
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
            <a
              href="tel:+15407764488"
              className="flex items-center justify-center gap-2.5 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white text-white font-black text-lg rounded-xl uppercase tracking-wide hover:bg-white hover:text-[#0f2018] transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl"></i>
              (540) 776-4488
            </a>
          </div>

          {/* Trust row */}
          <div className="flex flex-wrap gap-5">
            {[
              { icon: "ri-verified-badge-fill", text: "ISA Certified Arborists" },
              { icon: "ri-star-fill", text: "200+ 5-Star Reviews" },
              { icon: "ri-timer-flash-fill", text: "Same-Day Response" },
              { icon: "ri-map-pin-2-fill", text: "Northern Virginia Local" },
            ].map((b) => (
              <div key={b.text} className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${b.icon} text-[#e8632a] text-base`}></i>
                </div>
                <span className="text-white/80 text-sm font-semibold">{b.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats dock — bottom overlay */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#0f2018] border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-2 md:grid-cols-4">
          {[
            { number: "15+", label: "Years Serving VA" },
            { number: "2,400+", label: "Jobs Completed" },
            { number: "200+", label: "5-Star Reviews" },
            { number: "24/7", label: "Emergency Service" },
          ].map((stat, i) => (
            <div
              key={stat.label}
              className={`py-5 text-center ${i < 3 ? "border-r border-white/10" : ""}`}
            >
              <div className="text-[#e8632a] font-black text-3xl lg:text-4xl tracking-tight">{stat.number}</div>
              <div className="text-white/50 text-xs uppercase tracking-widest font-semibold mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
